import { type Theme } from "@mui/material/styles";
import { fontSize, lineHeight } from "../../theme/tokens";

/**
 * Shared Forest chart sx overrides.
 * Apply these to any @mui/x-charts component to get consistent Forest theming.
 */
export function getForestChartSx(theme: Theme) {
  const chart = theme.palette.chart;

  return {
    "& .MuiChartsAxis-line": { stroke: `${chart.axisFg} !important` },
    "& .MuiChartsAxis-tick": { stroke: `${chart.axisFg} !important` },
    "& .MuiChartsAxis-tickLabel": {
      fill: `${chart.labelFg} !important`,
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: `${fontSize.xxs}px !important`,
      lineHeight: lineHeight.xxs,
    },
    "& .MuiChartsAxis-label": {
      fill: `${chart.labelFgEmphasis} !important`,
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: `${typeof theme.typography.body1.fontSize === "number" ? theme.typography.body1.fontSize : 14}px !important`,
      fontWeight: theme.typography.fontWeightMedium,
    },
    "& .MuiChartsGrid-line": {
      stroke: chart.gridlineFg,
      strokeDasharray: "4 4",
    },
    "& .MuiChartsLegend-series text": {
      fill: `${chart.legendFg} !important`,
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: "14px !important",
    },
    "& .MuiChartsLegend-mark": {
      ry: 4,
      rx: 4,
      width: 12,
      height: 12,
    },
    "& .MuiChartsTooltip-root": {
      fontFamily: theme.typography.fontFamily,
      fontSize: typeof theme.typography.body1.fontSize === "number" ? theme.typography.body1.fontSize : 14,
    },
    "& .MuiChartsTooltip-table": {
      backgroundColor: chart.tooltipBg,
      color: chart.tooltipFg,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[4],
    },
  } as const;
}

/** Standard legend slotProps for Forest charts */
export const forestLegendSlotProps = {
  legend: {
    itemMarkWidth: 12,
    itemMarkHeight: 12,
    padding: { bottom: 20 },
  },
} as const;
